import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { SatelliteArchiveCostDTO, SatelliteArchiveImageryDTO } from '../../../../api/api-supplier';
import {
    actionSatelliteMouseOut,
    actionSatelliteMouseOver,
    actionSatelliteReorderZIndex,
    actionSatelliteSetFeatureActive,
    actionSatelliteSetFeatureInactive,
} from '../../../../store/Map/SatelliteArchive/actions';
import PriceWithCurrency from '../../../Shared/price-with-currency';
import { StyledButton } from '../../../Shared/styled-button';
import SatelliteArchiveSelectAndReorder from './satellite-archive-select-and-reorder';

interface SatelliteArchiveResultsProps {
    satelliteArchiveResults: SatelliteArchiveImageryDTO[];
    onSelectScenes: (selectedScenes: SatelliteArchiveImageryDTO[]) => void;
    selectedScenes: SatelliteArchiveImageryDTO[];
    satelliteArchiveCost?: SatelliteArchiveCostDTO;
    satelliteArchiveCostError?: Error;
    onClickCheckout: () => void;
}

const SatelliteArchiveResults = (props: SatelliteArchiveResultsProps) => {
    const { satelliteArchiveResults, onSelectScenes, satelliteArchiveCost, satelliteArchiveCostError, selectedScenes } =
        props;
    const [selectedResults, setSelectedResults] = useState(selectedScenes);
    const dispatch = useDispatch();

    const selectScenes = (scenes: SatelliteArchiveImageryDTO[]) => {
        setSelectedResults(scenes);
        onSelectScenes(scenes);
    };

    return (
        <React.Fragment>
            <SatelliteArchiveSelectAndReorder
                results={satelliteArchiveResults}
                reorderScene={(newOrder) => dispatch(actionSatelliteReorderZIndex(newOrder))}
                selectedResults={selectedResults}
                setResultActive={(result: SatelliteArchiveImageryDTO) => {
                    selectScenes([...selectedResults, result]);
                    dispatch(actionSatelliteSetFeatureActive(result));
                }}
                setResultInactive={(result: SatelliteArchiveImageryDTO) => {
                    selectScenes(selectedResults.filter((t) => t.id !== result.id));
                    dispatch(actionSatelliteSetFeatureInactive(result));
                }}
                setResultMouseOver={(result: SatelliteArchiveImageryDTO) => {
                    dispatch(actionSatelliteMouseOver(result));
                }}
                setResultMouseOut={() => {
                    dispatch(actionSatelliteMouseOut());
                }}
            >
                <ResultsText>
                    {selectedResults.length} of {satelliteArchiveResults.length} results selected
                </ResultsText>

                {selectedResults.length > 0 && !satelliteArchiveCost && !satelliteArchiveCostError ? (
                    <PurchaseButton disabled>
                        <i className="fa fa-spinner fa-spin" />
                    </PurchaseButton>
                ) : null}

                {selectedResults.length > 0 && satelliteArchiveCostError ? (
                    <ErrorText>Not enough scenes.</ErrorText>
                ) : null}

                {selectedResults.length > 0 && satelliteArchiveCost && !satelliteArchiveCostError ? (
                    <PurchaseButton onClick={props.onClickCheckout}>
                        Purchase for{' '}
                        <PriceWithCurrency
                            value={satelliteArchiveCost.totalPrice}
                            currency={satelliteArchiveCost.currency}
                        />
                    </PurchaseButton>
                ) : null}
            </SatelliteArchiveSelectAndReorder>
        </React.Fragment>
    );
};

export default SatelliteArchiveResults;

const ResultsText = styled.p`
    color: white;
    margin: 7px 0 0 10px;
    min-width: 160px;
`;

const ErrorText = styled.p`
    color: red;
    margin: 7px 10px 0 0;
`;

const PurchaseButton = styled(StyledButton)`
    min-width: 217px;
`;
